<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.14 7.17C18.0464 7.06341 17.9119 7.00161 17.77 7H14V5.59C14 5.31 14.06 4.99 14.51 4.99H17.51C17.6434 4.99569 17.7721 4.94051 17.86 4.84C17.9482 4.74856 17.9982 4.627 18 4.5V0.5C18 0.223858 17.7761 0 17.5 0H13.17C8.37 0 8 4.1 8 5.35V7H5.5C5.22386 7 5 7.22386 5 7.5V11.5C5 11.7761 5.22386 12 5.5 12H8V23.5C8 23.7761 8.22386 24 8.5 24H13.5C13.7761 24 14 23.7761 14 23.5V12H17.35C17.6077 12.0013 17.8242 11.8065 17.85 11.55L18.27 7.55C18.2817 7.41073 18.2345 7.27293 18.14 7.17Z" fill="#1877F2"></path></svg>
</template>

<script>
  export default {
    name: 'FacebookLoginIcon'
  }
</script>
